import { IClauseType, IPolicyType, IScopeClause } from "@/api";

export interface IOverlappingClauseInfo {
    scopeClauseId: number;
    clauseId: number;
    clauseTitle: string;
    highlightColor: string;
    policyType: IPolicyType;
    clauseTypes: IClauseType[];
    topicName?: string | null;
}

export interface IScopeClauseWithTopic extends IScopeClause {
    scopeTopicId?: number | null;
    scopeTopicName?: string | null;
}

export interface IGroupedScopeClause {
    clause: IScopeClause["clause"];
    scopeClauses: IScopeClauseWithTopic[];
    highlightColor: string;
}

export enum ScopeDetailsTab {
    FIELDS,
    CLAUSES,
}

export enum ScopeViewType {
    OVERVIEW,
    DETAILS,
}

export enum FoundToggleState {
    FOUND,
    NOT_FOUND,
}
